module.exports = __webpack_public_path__ + "img/MAIA.776bf14d.png";